import React from 'react';
import './Offering.css';
import { Helmet } from 'react-helmet-async';



const Dozenten = () => {
    return (
        <>
        <Helmet>
            <title>Dozenten und Vortragtätigkeit</title>
            <meta name="description" content='In meinen 30 Jahren als Selbstständige habe ich zahlreiche Vorträge zu verschiedenen Ernährungsthemen gehalten und diverse Kochkurse mit unterschiedlichen Schwerpunkten durchgeführt. Bei Interesse an einem Vortrag (interaktiv in kleiner Gruppe oder vor großem Publikum) oder einem Kochkurs 
            bzw. Workshop kontaktieren Sie mich bitte.' />
        </Helmet>
        <div className='Dozenten'>
            <div className="BeratungWrapper">
                <div className='entrycontent'>

                    <h2 className='header'>Dozenten- und Vortragtätigkeit</h2>

                    <p className='text'>Im Laufe meiner 30 jährigen Selbständigkeit habe ich sehr viele Vorträge zu verschiedenen Ernährungsthemen gehalten und zahlreiche Kochkurse mit unterschiedlichsten Themenschwerpunkten durchgeführt. Diese alle aufzuzählen, würde den Rahmen sprengen.
                        Sollten Sie Interesse an einem Vortrag  ( ob interaktiv in kleiner Gruppe oder vor großem Publikum ) oder einem Kochkurs bzw. Workshop  haben, kontaktieren Sie mich einfach.</p>
                </div>

            </div >

        </div>
        </>);
}

export default Dozenten;